<template>
  <div id="login">
    <h2>Sign up</h2>
    <br />
    <form @submit.prevent="RegisterUser()">
    <div>
      <InputText
        class="p-mr-3"
        type="text"
        v-model="form.name.first"
        placeholder="First Name"
      />
      <InputText type="text" v-model="form.name.last" placeholder="Last Name" />
      <InputText
        type="text"
        v-model="form.persno"
        placeholder="GCSS-Army Personnel #"
      />
    </div>

    <br />

    <Dropdown
      v-model="form.uic"
      :options="uics"
      optionLabel="id"
      placeholder="Select Your UIC"
      :filter="true"
      filterPlaceholder="Find Your UIC"
    />

    <br />
    <br />

    <div>
      <div class="p-input-icon-left p-mr-3">
        <i class="pi pi-user" />
        <InputText type="text" v-model="form.email1" placeholder="Email" />
      </div>
      <div class="p-input-icon-left">
        <i class="pi pi-user" />
        <InputText
          type="text"
          v-model="form.email2"
          placeholder="Confrim Email"
        />
      </div>
    </div>

    <br />

    <div>
      <div class="p-input-icon-left p-mr-3">
        <i class="pi pi-lock" />
        <InputText
          type="password"
          v-model="form.password1"
          placeholder="Password"
        />
      </div>
      <div class="p-input-icon-left">
        <i class="pi pi-lock" />
        <InputText
          type="password"
          v-model="form.password2"
          placeholder="Confirm Password"
        />
      </div>
    </div>
    <br />
    <br />
    <Button
      label="Back"
      @click="GoBack()"
      icon="pi pi-arrow-left"
      iconPos="left"
      class="p-mr-2"
    />
    <Button
      label="Submit"
      type="submit"
      icon="pi pi-sign-in"
      iconPos="right"
    />
    </form>
    <br />
    <Toast position="bottom-center" />
  </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import { fb_auth, fb_users, fb_db } from "../firebase";
// import uics from "@/assets/uic.js";
// import roles from "@/assets/roles.js";

export default {
  name: "Signup",
  components: {
    Dropdown,
  },
  data() {
    return {
      form: {
        email1: null,
        email2: null,
        password1: null,
        password2: null,
        uic: null,
        puic: null,
        persno: null,
        name: {
          first: null,
          last: null,
        },
      },
      uics: [],
    };
  },
  async mounted() {
    await this.getUICs();
  },
  methods: {
    async getUICs() {
      let uicData = await fb_db.collection("uics").get()
      uicData.forEach((doc) => {
        let item = doc.data();
        item.id = doc.id;
        this.uics.push(item);
      });
    }, 
    GoBack() {
      this.$router.push({ path: "/" });
    },
    async RegisterUser() {
  //     let userRef = fb_db.collection("users").doc(fb_auth.currentUser.uid)
  //     let userData = await userRef.get()
  //     let user = userData.data()
  // // move to registration sign up page to set the PUIC and UIC on the user object
  //       let puic = await fb_db.collection("uics").doc(user.uic).get()
      if (
        this.form.email1 == this.form.email2 &&
        this.form.password1 == this.form.password2
      ) {
        fb_auth
          .createUserWithEmailAndPassword(this.form.email1, this.form.password1)
          .then((response) => {
            console.log("user auth created: ", response);
            // create user obj
            fb_users
              .doc(response.user.uid)
              .set({
                firstname: this.form.name.first,
                lastname: this.form.name.last,
                uic: this.form.uic.id, 
                puic: this.form.uic.puic,
                persno: this.form.persno,
                role: null,
                approved: false,
                email: this.form.email1,
              })
              .then(() => {
                this.$router.push("/awaitingapproval");
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            if (errorCode == "auth/wrong-password") {
              errorCode = "Incorrect Password";
            }
            var errorMessage = error.message;
            console.log(errorCode, errorMessage);
            this.$toast.add({
              severity: "error",
              summary: "errorcode",
              detail: "Login Message",
              life: 3000,
            });
          });
      } else {
        if (this.form.email1 != this.form.email2) {
          this.$toast.add({
            severity: "warn",
            summary: "Email mismatch",
            detail: "Email must be the same.",
            life: 3000,
          });
        } else if (this.form.password1 != this.form.password2) {
          this.$toast.add({
            severity: "warn",
            summary: "Password mismatch",
            detail: "Password must be the same.",
            life: 3000,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  color: #999999;
  text-align: left;
  width: 400px;
  margin: 0 auto;

  input {
    width: 400px;
  }
}
</style>